import { useState } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

export let language = 'en';
export const setLanguage = (newLanguage) => {
  language = newLanguage || 'en';
};

// Lightweight CSV-based i18n loader
// Looks for CSV files at /i18n/<page_name>.csv with header: en,es,fr
// Each subsequent row corresponds to the same index across languages.
const csvCache = {};
const csvLoading = {};

function parseCsv(text) {
  const rows = [];
  let row = [];
  let cur = '';
  let inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (inQuotes) {
      if (ch === '"') {
        if (text[i + 1] === '"') {
          cur += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        cur += ch;
      }
    } else {
      if (ch === '"') {
        inQuotes = true;
      } else if (ch === ',') {
        row.push(cur);
        cur = '';
      } else if (ch === '\n') {
        row.push(cur);
        rows.push(row);
        row = [];
        cur = '';
      } else if (ch === '\r') {
        // ignore
      } else {
        cur += ch;
      }
    }
  }
  if (cur.length > 0 || row.length > 0) {
    row.push(cur);
    rows.push(row);
  }
  return rows;
}

function ensureCsvLoaded(pageName) {
  if (csvCache[pageName] || csvLoading[pageName]) return;
  csvLoading[pageName] = true;
  try {
    fetch(`/i18n/${pageName}.csv`, { cache: 'no-store' })
      .then((r) => (r.ok ? r.text() : null))
      .then((text) => {
        if (!text) return;
        const rows = parseCsv(text).filter((r) => r.length && r.some((c) => c && c.trim().length));
        if (rows.length < 2) return;
        const header = rows[0].map((h) => (h || '').trim());
        const langIdx = {
          en: header.indexOf('en'),
          es: header.indexOf('es'),
          fr: header.indexOf('fr'),
        };
        const makeCol = (code) =>
          langIdx[code] >= 0
            ? rows.slice(1).map((r) => (r[langIdx[code]] || '').trim())
            : null;
        csvCache[pageName] = {
          en: makeCol('en'),
          es: makeCol('es'),
          fr: makeCol('fr'),
        };
      })
      .catch(() => {})
      .finally(() => {
        csvLoading[pageName] = false;
      });
  } catch (e) {
    csvLoading[pageName] = false;
  }
}

export const itemPage = (item,page_name)=>
{ 
  const pages = languagePages(page_name,language);
  const index = findIndexUsingEnglish(item,page_name);
  if(index === -1) {
    console.log("not found: item, pagename:",item,page_name);
    return item;
  }
  return pages[index];
}

const languageItemPages = (item,page_name,language)=>
    {
      const pages = languagePages(page_name,language);
      const index = findIndexUsingEnglish(item,page_name);
      if(index === -1) {
        console.log("not found: item, pagename:",item,page_name);
        return item;
      }
      return pages[index];
    }
    
    
      const findIndexUsingEnglish = (item,page_name)=>
    {
      console.log("finding index: item, pagename:",item,page_name);
      const pages = languagePages(page_name,"en");
      console.log("pages:",pages);
      const index = pages.indexOf(item);
      if(index === -1) {
        console.log("not found: item, pagename:",item,page_name);

      }
      return index;
    }
    
    export const languagePages = (page_name,language)=>
    {
    // Attempt to use CSV-backed pages first
    ensureCsvLoaded(page_name);
    const csv = csvCache[page_name];
    if (csv && csv[language]) {
      return csv[language];
    }
    
    
    const english_login_page =
    [
      "Waiting for mission start",
      "User",
      "Password",
      "Login",
      "MISSION: SUBSPACE",
      "Start"
    ];
    
    const spanish_login_page =
      [
        "Esperando el inicio de la misión",
        "Usuario",
        "Contraseña",
          "Acceso",
          "MISIÓN: SUBESPACIO",
          "Iniciar"
    ];
    
    
    const french_login_page =
    [
      "En attente du début de la mission",
      "Utilisateur",
      "Mot de passe",
      "Se connecter",
      "MISSION : SOUS-ESPACE",
      "Lancer"
    ];
    
    

    
    
    
    
        const english_footer =
        [
          "Full screen",
          "Data provided by:",
          "×",
          "© 2025 Microsoft Corporation",
          "Earthstar Geographics  SIO",
          "© 2025 TomTom",
          "Data available from the U.S. Geological Survey, © CGIAR-CSI, Produced using Copernicus data and information funded by the European Union - EU-DEM layers, Data available from Land Information New Zealand, Data available from data.gov.uk, Data courtesy Geoscience Australia",
          "© 2025 Zenrin",
          "Bing Imagery"
      ];
    
        const spanish_footer =
      //   [
      //     "Pantalla completa",
      //     "Datos proporcionados por:",
      //     "×",
      //     "© 2025 Microsoft Corporation",
      //     "Earthstar Geographics  SIO",
      //     "© 2025 TomTom",
      //     "Data available from the U.S. Geological Survey, © CGIAR-CSI, Produced using Copernicus data and information funded by the European Union - EU-DEM layers, Data available from Land Information New Zealand, Data available from data.gov.uk, Data courtesy Geoscience Australia",
      //     "© 2025 Zenrin",
      //     "Bing Imagery"
      // ]
    
      [
        "Pantalla completa",
        "Datos proporcionados por:",
        "×",
        "© 2025 Microsoft Corporation",
        "Earthstar Geographics SIO",
        "© 2025 TomTom",
        "Datos disponibles del Servicio Geológico de Estados Unidos, © CGIAR-CSI, producidos con datos de Copernicus e información financiada por la Unión Europea - capas EU-DEM, datos disponibles de Land Information New Zealand, datos disponibles de data.gov.uk, datos cortesía de Geoscience Australia",
        "© 2025 Zenrin",
        "Imá;genes de Bing"
    ];
    
    const french_footer =
    [
      "Mise à niveau pour une utilisation commerciale.",
      "© 2025 Microsoft Corporation",
      "Earthstar Geographics SIO",
      "Données disponibles auprès de l&#39;US Geological Survey, © CGIAR-CSI, produites à partir des données Copernicus et d&#39;informations financées par l&#39;Union européenne - couches EU-DEM, données disponibles auprès de Land Information New Zealand, données disponibles sur data.gov.uk, données fournies par Geoscience Australia",
      "Images Bing"
    ];
    
  
    
    
    
    const french_admin_page =
    [
      "Mission : Administrateur du sous-espace",
      "Noms des chipsets",
      "Chipsat 01",
      "Chipsat 03",
      "Chipsat 05",
      "Chipsat 07",
      "Chipsat 09",
      "Sauvegarder",
      "Définir des mots de passe",
      "Mot de passe administrateur",
      "Ensemble",
      "Mot de passe du diffuseur",
      "Mot de passe de l'enseignant",
      "Mot de passe étudiant",
      "Paramètres de flux",
      "Flux",
      "Participants",
      "Contrôle de mission",
      "Commencer",
      "Déconnexion",
      "onglets",
      "MISSION : SOUS-ESPACE",
      "Restreindre le flux à l'administrateur"
  ];

  const english_admin_page =
  [
    "Mission: Subspace Admin",
    "Chipsat Names",
    "Chipsat 01",
    "Chipsat 03",
    "Chipsat 05",
    "Chipsat 07",
    "Chipsat 09",
    "Save",
    "Set passwords",
    "Admin password",
    "Set",
    "Broadcaster password",
    "Teacher password",
    "Student password",
    "Stream settings",
    "Stream",
    "Participants",
    "Mission Control",
    "Start",
    "Logout",
    "tabs",
    "MISSION: SUBSPACE",
    "Restrict stream to admin"
];

const spanish_admin_page =
[
  "Misión: Administración del subespacio",
  "Nombres de chipsat",
  "Chipsat 01",
  "Chipsat 03",
  "Chipsat 05",
  "Chipsat 07",
  "Chipsat 09",
  "Ahorrar",
  "Establecer contraseñas",
  "Contraseña de administrador",
  "Colocar",
  "Contraseña de la emisora",
  "Contraseña del profesor",
  "Contraseña de estudiante",
  "Configuración de transmisión",
  "Arroyo",
  "Participantes",
  "Control de misión",
  "Comenzar",
  "Cerrar sesión",
  "cortina a la italiana",
  "MISIÓN: SUBESPACIO",
  "Restringir la transmisión al administrador"
];


    let front_page = [];
    let footer = english_footer;
    let login_page = english_login_page;
    let admin_page = english_admin_page;
    switch(language) {
      case "en":
        footer = english_footer;
        login_page = english_login_page;
        admin_page = english_admin_page;
        break;
      case "es":
        footer = spanish_footer;
        login_page = spanish_login_page;
        admin_page = spanish_admin_page;  
        break;
      case "fr":
        footer = french_footer;
        login_page = french_login_page;
        admin_page = french_admin_page;
        break;
    }
    
     if(page_name === "footer") {
      return footer;
     }  else if(page_name === "mission_space") {
      return front_page;
     } else if(page_name === "front_page" || page_name === "leaderboard" || page_name === "stats_viewer" || page_name === "chart_variables") {
      // Route legacy page keys to mission_space CSV if present
      ensureCsvLoaded('mission_space');
      const csv = csvCache['mission_space'];
      if (csv && csv[language]) return csv[language];
      return front_page;
     } else if(page_name === "login_page") {
      return login_page;
      } else if(page_name === "admin_page") {
        return admin_page;
      }
    
    
    }

// Reusable language selector component
export const LanguageSelector = ({ value, onChange, fixed = true }) => {
  const [selected, setSelected] = useState(value || language || 'en');

  const handleChange = (event, newValue) => {
    if (!newValue) return;
    setSelected(newValue);
    setLanguage(newValue);
    if (onChange) onChange(newValue);
  };

  const wrapperStyle = fixed
    ? { position: 'fixed', top: 45, left: 1500, zIndex: 2000, background: 'rgba(255,255,255,0.95)', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.15)', padding: 4 }
    : undefined;

  return (
    <div style={wrapperStyle}>
      <ToggleButtonGroup
        size="small"
        value={value !== undefined ? value : selected}
        exclusive
        onChange={handleChange}
        aria-label="Language selector"
      >
        <ToggleButton value="en" aria-label="English"><img src="https://flagcdn.com/gb.svg" alt="English" style={{ width: 22, height: 16, display: 'block' }} loading="lazy" /></ToggleButton>
        <ToggleButton value="es" aria-label="Spanish"><img src="https://flagcdn.com/es.svg" alt="Spanish" style={{ width: 22, height: 16, display: 'block' }} loading="lazy" /></ToggleButton>
        <ToggleButton value="fr" aria-label="French"><img src="https://flagcdn.com/fr.svg" alt="French" style={{ width: 22, height: 16, display: 'block' }} loading="lazy" /></ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};